import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3903baf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "largeTitle",
    colspan: "4"
  }, "Qualifikation Block II"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "largeTitle",
    colspan: "3"
  }, "Gesamtqualifikation")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Fach", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "schriftlich", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "mündlich", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "unusedField" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "resultField" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "resultField" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "resultField" }, null, -1))
const _hoisted_10 = { class: "resultField" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarkInputComponent = _resolveComponent("MarkInputComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("tr", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("th", null, " Gewichtung " + _toDisplayString(_ctx.subjectsMuendlich.length == 1 ? "fünffach" : "vierfach"), 1),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
      return _createElementVNode("tr", { key: i }, [
        _createElementVNode("td", null, _toDisplayString(_ctx.ownSubjects[i - 1]), 1),
        _createElementVNode("td", null, [
          _createVNode(_component_MarkInputComponent, {
            modelValue: _ctx.singlePointsQuali2[i - 1],
            "onUpdate:modelValue": ($event: any) => ((_ctx.singlePointsQuali2[i - 1]) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _hoisted_5,
        _createElementVNode("td", null, _toDisplayString(_ctx.subjectsMuendlich.length == 1
          ? _ctx.singlePointsQuali2[i - 1] * 5
          : _ctx.singlePointsQuali2[i - 1] * 4), 1)
      ])
    }), 64)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectsMuendlich, (subject, i) => {
      return (_openBlock(), _createElementBlock("tr", { key: i }, [
        _createElementVNode("td", null, _toDisplayString(subject), 1),
        _hoisted_6,
        _createElementVNode("td", null, [
          _createVNode(_component_MarkInputComponent, {
            modelValue: _ctx.singlePointsQuali2[i + 3],
            "onUpdate:modelValue": ($event: any) => ((_ctx.singlePointsQuali2[i + 3]) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("td", null, _toDisplayString(_ctx.subjectsMuendlich.length == 1
          ? _ctx.singlePointsQuali2[i + 3] * 5
          : _ctx.singlePointsQuali2[i + 3] * 4), 1)
      ]))
    }), 128)),
    _createElementVNode("tr", null, [
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("td", _hoisted_10, "Summe: " + _toDisplayString(_ctx.getTotalQuali2()), 1)
    ])
  ], 64))
}